<template>
  <Hoxton :revinate_token="revinate_token" :background_image="background_image" :template="template" :portal="portal" :connection_data="connection_data" @emitRegistrationMethodData="handleEmit" />
</template>

<script>
import Hoxton from '@/components/custom/hoxton/index'
export default {
  name: 'custom_template_hoxton_chicago',
  props: [ 'template', 'portal', 'connection_data' ],
  components: { Hoxton },
  data(){
    return{
      background_image: `https://sky-production.s3.amazonaws.com/brandportalimages/hox-chi-bg.jpeg`,
      revinate_token: 'b54b04f7-b313-4b1b-9812-3312a29ccbe3'
    }
  },
  methods: {
    handleEmit:function(data){
      this.$emit('emitRegistrationMethodData', data);
    }
  }
}
</script>
<style>
</style>
